// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----header-module---header---1a1MQ","navigation":"src-components-Header----header-module---navigation---236HK","registerButton":"src-components-Header----header-module---registerButton---3giCa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.scss
// module id = 316
// module chunks = 168707334958949